import { render } from "./SecondaryNavigation.vue?vue&type=template&id=4aca92e8"
import script from "./SecondaryNavigation.vue?vue&type=script&lang=js"
export * from "./SecondaryNavigation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Desktop\\dev\\dma-sc-question-edits\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__